import { useEffect } from "react";
import Logo from "./Logo";
import ContactForm from "./ContactForm";

function Apparel04 ({ setBg, toppage }) {
    useEffect(() => {
        setBg('bg-apparel04-m md:bg-apparel04 md:bg-left-top');
        toppage.current?.scrollIntoView({behavior: 'smooth'});
    }, [setBg, toppage]);

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-row">
                <div className="md:w-1/3">
                    <div className="h-[280px] md:h-[250px]" />
                    <div className="md:mx-12 mx-6 mb-12">
                        <span className="align-middle font-goodtimes text-xl md:text-3xl px-5 py-2 text-primary-darker-yellow bg-primary-yellow leading-tight">APPAREL</span>
                        <div className="font-goodtimes text-4xl mt-5 md:text-5xl text-primary-yellow w-11/12">
                            <div>ATG ARMORED STEALTH JACKET</div>
                        </div>
                    </div>
                </div>
                <div className="md:block hidden md:w-2/3 md:pl-96 md:pr-56 md:pt-24">
                    <Logo />
                </div>
            </div>
            <div className="bg-white flex flex-col md:flex-row md:justify-between md:bg-btmbg md:bg-contain md:bg-right-bottom">
                <div className="md:w-1/3">
                    <div className="mx-6 md:ml-12">
                        <div className="mt-5 font-bold">Stylish, warm, functional and bulletproof</div>
                        <div className="w-11/12">
                            Designed to resemble a classic down jacket, this undercover vest hides in plain view - appearing wholly unremarkable to the outside world. Protecting from handguns and fragmentation, this jacket seamlessly blends into everyday life in both form and function.
                        </div>
                    </div>
                    <div className="text-[#9D9D9C] font-acier text-4xl pt-5 mx-6 md:ml-12">
                        FEATURES
                    </div>
                    <div className="bg-primary-yellow pb-5 mx-6 md:ml-12">
                        <ol className="list-decimal pl-8 pr-6 py-2">
                            <li>
                                Appearance identical to a modern monochrome Puffer Jacket
                            </li>
                            <li>
                                Balanced weight with ergonomic fitting
                            </li>
                            <li>
                                Durable and adaptable with advanced materials and expert craftsmanship
                            </li>
                            <li>
                                Compatible with all belts and holsters
                            </li>
                            <li>
                                Compatible with all plate carriers
                            </li>
                            <li>
                                Soft armor protection provided by UHMWPE panels of NIJ 0101.06: IIa, II, and IIIa
                            </li>
                        </ol>
                    </div>

                    <div className="mt-5 mx-6 md:mx-12">
                        <img className="h-auto w-[200%]" src={require('./assets/02-apparel04-01.png')} alt="" draggable="false" />
                    </div>
                </div>

                <div className="md:w-1/3 mb-8">
                    <div className="flex flex-col md:ml-6 mt-5">
                        <div className="mx-20 md:mx-36 mx- grow">
                            <img className="h-auto w-[200%]" src={require('./assets/02-apparel04-02.png')} alt="" draggable="false" />
                        </div>
                        <div className="mx-20 md:mx-32 grow">
                            <img className="h-auto w-[200%]" src={require('./assets/02-apparel04-03.png')} alt="" draggable="false" />
                        </div>
                    </div>
                </div>

                <div className="px-6 pb-12 md:w-1/3 md:px-12">
                    <ContactForm />
                </div>

            </div>
        </div>

    );
}

export default Apparel04;
